import React from 'react';
import { Outlet } from 'react-router-dom';
import SpinnerTw from '~/components/SpinnerTw';
import SuspendedArea from './SuspendedArea';

export default function SuspendedOutlet({
  fallback = <SpinnerTw center={true} />
}: {
  fallback?: React.ReactNode
}) {
  return (
    <SuspendedArea fallback={fallback}>
      <Outlet />
    </SuspendedArea>
  );
}; 